import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgXdropdownarrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.5 5.25L7 8.75L10.5 5.25",
		stroke: "#002449",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgXdropdownarrow;
